module.exports = __webpack_public_path__ + "static/media/underConstructionPage.d27feb6a.jpg";